<template>
  <div class="InstallApp">
    <div v-show="isLoading">
      <PreLoad />
    </div>
    <div v-show="!isLoading" class="container mb-5">
      <div class="row" dir="rtl">
        <div class="col-lg-6 col-md-6 col-sm-12 col-12 mb-3">
          <img src="../../assets/app.webp" class="w" alt="فروشگاه نورا">
        </div>
        <div class="col-lg-6 col-md-6 col-sm-12 col-12 mb-3 flx" dir="rtl">
          <h1>نوراشاپ اپلیکیشنی برای خرید آسان</h1>
          <p>به کمک نرم افزار نورا شما می توانید خریدی آسانتر و دسترسی راحت تر به سفارشات خود داشته باشید.</p>
          <h2>خدمات اپلیکیشن نورا</h2>
          <p>از طریق این نرم افزار شما با دریافت پیشنهادات ویژه می توانید از تخفیف‌ها و مناسبت‌های نورا خبردار شوید. <br>
           علاوه بر آن می توانید با دسترسی به پنل کاربری و نوتیفیکیشن نرم افزار از وضعیت سفارشات خود آگاهی پیدا کنید.<br>
          همچنین در زمان‌هایی که اینترنت ندارید می توانید از فروشگاه استفاده کنید (به غیر از مراحل ثبت سفارش).<br>
          ویژگی‌های فوق العاده‌ای در این نرم افزار برای شما قرار خواهد گرفت , که اگر همین الان اون رو نصب کنید به اولین نفر‌هایی که می‌توانند از آن استفاده کنند تبدیل خواهید شد.
          </p>
          <h2>پشتیبانی نرم افزار</h2>
          <p>در صورت بروز هرگونه مشکل می‌توانید از راه‌های ارتباطی در صفحه (<router-link to="/contact" class="text-info">ارتباط‌با‌ما</router-link>) در تماس باشید.</p>
          <button v-if="showInstallButton" class="btn btn-primary2 m-2" @click="installApp">نصب برنامه</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import PreLoad from '@/components/PreLoad.vue'

export default {
  name: 'InstallApp',
  components: {
    PreLoad
  },
  data () {
    return {
      showInstallButton: false,
      isLoading: true
    }
  },
  methods: {
    handleInstallPrompt (event) {
      this.showInstallButton = true
      this.deferredPrompt = event
    },
    installApp () {
      if (this.deferredPrompt) {
        this.deferredPrompt.prompt()
        this.deferredPrompt.userChoice.then((choiceResult) => {
          if (choiceResult.outcome === 'accepted') {
            console.log('User accepted the install prompt')
          } else {
            console.log('User dismissed the install prompt')
          }
          this.deferredPrompt = null
        })
      }
    }
  },
  mounted () {
    window.addEventListener('beforeinstallprompt', this.handleInstallPrompt)
  },
  beforeMount () {
    const query = `
    {
      meta(key:"${this.$options.name}") {
        seoTitle
        seoKeyword
        seoDescription
      }
    }
    `
    this.$fetchGraphQL(query).then(res => {
      this.setMetaByObj(res.data.meta)
      this.isLoading = false
    })
  }
}
</script>

<style scoped>
.w{
  width: fit-content;
  width: -moz-available;
  max-width: 100%;
}
.flx{
  display: flex;
  flex-direction: column;
  justify-content: center;
}
p {
  color:rgba(0,0,0,.55);
  margin-bottom: 3rem;
}
h1 {
  font-size:17pt;
}
h2 {
  font-size:15pt;
}
h3 {
  font-size:13pt;
}
.card{
  border-radius: 24px;
  min-width: 250px;
  margin: 10px;
}
.mb-6{
  margin-bottom: 5rem;
}
</style>
